import PropTypes from 'prop-types';
import React from 'react';
import { LOADING_MESSAGE } from '../Messages/Messages';
import style from './loader.module.scss';

/* This is a DS component that isn't available in their react package yet */

const Loader = ({
  variant = 'spinner',
}) => (
  <span className={style.loader} data-testid="loader" data-variant={variant}>
    <span />
    <span />
    {(variant === 'spinner') ? (
      <>
        <span />
        <span />
        <span />
        <span />
      </>
    ) : ''}
    <span className="screen-reader-text">{LOADING_MESSAGE}</span>
  </span>
);

Loader.propTypes = {
  variant: PropTypes.string,
};

export default Loader;
